module.exports = __webpack_public_path__ + "img/Asistenciavialplus.17af9bd5.svg";